module.exports = __webpack_public_path__ + "img/rating_full.c6ca2313.svg";